export class HumanizedError extends Error {
  constructor(public humanizedMessage: string, public message: string, public code?: string) {
    super(message)
  }
}

export default HumanizedError
